<template>
  <base-modal modal-id="verify-number">
    <template v-slot:header>
      <button type="button" class="btn btn-arrow" @click="proceedBack">
        <img src="/images/svg/global/left_arrow.svg" alt />
      </button>
      <h4 class="modal-title mb-0 d-sm-block d-none">{{_T('Input Verification Code')}}</h4>
      <h4 class="modal-title mb-0 d-sm-none">{{_T('Verification Code')}}</h4>
    </template>
    <template v-slot:modal-body>
      <form class="default-form verification-code">
        <div class="form-group">
          <label>
            <span>{{_T('A verification code has been sent to the number')}}</span>
            (+{{otp_progress_reference}})
          </label>
          <div class="digit-group">
            <input
              type="text"
              :id="'digit-'+index"
              :name="'digit-'+randStr()"
              :data-next="'digit-'+(index+1)"
              :ref="'digit-ref-'+index"
              :key="index"
              v-for="(item,index) in inputFields"
              v-model="inputFields[index]"
              @input="handleOnChange($event,index)"
              @keydown="handleOnKeyDown($event,index)"
              @keyup="handleKeyUp($event,index)"
              @paste="handleOnPaste($event,index)"
              @focus="handleOnFocus($event,index)"
              autocomplete="new-password"
            />
          </div>
          <b-form-invalid-feedback :state="otp_progress_fail">
                    {{otp_verification.error_message}}
          </b-form-invalid-feedback>
        </div>
        <button type="button" class="btn btn-danger btn-block" @click="confirmOTP">{{_T('Verfiy')}}</button>
        <h6>
          {{_T('Did not received code?')}}
          <span
            class="font-primary"
            @click="genrateOTP"
          >{{_T('Resend')}}</span>
        </h6>
      </form>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from '../BaseModal'
import { mapGetters } from 'vuex'
import * as CONST from '@/constants'
import { generateRandomString } from '@/utils/main_utils'
export default {
	props: {
		value: {
			type: String,
		},
		sendOtpOnLoad: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			timer: 0,
			inputFields: [],
		}
	},
	name: 'VerifyNumber',
	components: {
		BaseModal,
	},
	computed: {
		...mapGetters([
			'_T',
			'otp_verification',
			'otp_progress',
			'otp_progress_fail',
			'otp_confirmed',
			'otp_progress_reference',
		]),
		code() {
			return this.inputFields.join('')
		},
	},
	mounted() {
		for (var i = 0; i < CONST.OTP_LENGTH; i++) this.inputFields.push('')
		if (this.sendOtpOnLoad) {
			this.genrateOTP()
		}
	},
	methods: {
		proceedBack() {
			this.$bvModal.hide('verify-number')
			this.$bvModal.show('change-number')
		},
		proceedFurther() {
			this.$bvModal.hide('verify-number')
		},
		handleOnChange(event, currentIndex) {
			this.oneValuePerInput()
			return this.$emit('on-change', this.model)
		},
		handleKeyUp(event, currentIndex) {
			this.oneValuePerInput()
			if (currentIndex + 1 != CONST.OTP_LENGTH) {
				this.$refs['digit-ref-' + (currentIndex + 1)][0].focus()
			}
		},
		handleOnKeyDown(event, currentIndex) {
			// Only allow characters 0-9, DEL, Backspace and Pasting
			const keyevent = event || window.event
			const charCode = keyevent.which ? keyevent.which : keyevent.keyCode
			if (
				this.isCodeNumeric(charCode) ||
				charCode === 8 ||
				charCode === 86 ||
				charCode === 46
			) {
				this.$emit('on-keydown', event)
			} else {
				keyevent.preventDefault()
			}
			this.oneValuePerInput()
		},
		oneValuePerInput() {
			let that = this
			this.inputFields.forEach((element, k) => {
				if (String(element).length > 1) {
					that.inputFields[k] = element.slice('')[0]
				}
			})
		},
		isCodeNumeric(charCode) {
			return (
				(charCode >= 48 && charCode <= 57) ||
				(charCode >= 96 && charCode <= 105)
			)
		},
		handleOnPaste(event, currentIndex) {
			return this.$emit('on-paste', event)
		},
		handleOnFocus(event, currentIndex) {
			this.oneValuePerInput()
			return this.$emit('on-focus')
		},
		genrateOTP() {
			this.$store.dispatch('sendOTP', {
				mode: 'mobile',
				reference: this.mobile,
			})
		},
		confirmOTP() {
			var that = this
			this.$store.dispatch('confirmOTP', this.code).then(result => {
				if (that.otp_confirmed) {
          that.proceedFurther()
          that.$emit('onSuccess',that.otp_confirmed)
					that.inputFields.forEach((e, i) => {
						that.inputFields[i] = ''
					})
				}
			})
		},
		randStr() {
			return generateRandomString()
		},
	},
	watch: {
		inputFields() {},
	},
}
</script>

<style lang="scss" scoped></style>
